import {InjectionToken} from '@angular/core';
import {PaymentGateway, PaymentMethod} from '../../model/payment.model';

export interface PaymentGatewayResolution {
  gateway: PaymentGateway;
  sourceId?: string;
}

export interface PaymentGatewayResolver {
  resolve(method: PaymentMethod): PaymentGatewayResolution;
}

export const PAYMENT_GATEWAY_RESOLVER = new InjectionToken<PaymentGatewayResolver>('PAYMENT_GATEWAY_RESOLVER');

